import React from "react"
import { Button, Palette, useTheme } from "@mui/material"
import { MultilangJob } from "src/services/api/document"

export const languagesRowLabelColor = (multilangJob: MultilangJob, palette: Palette) => {
  if (multilangJob.status === "FINISHED") {
    return (palette.electricMint as any)[100]
  }
  if (multilangJob.status === "QUOTING" || multilangJob.status === "QUOTED") {
    return (palette.lightGold as any)[100]
  }
  return (palette.lightSkyBlue as any)[300]
}

const buttonBorderColor = (multilangJob: MultilangJob, palette: Palette) => {
  if (multilangJob.status === "FINISHED") {
    return (palette.electricMint as any)[200]
  }
  if (multilangJob.status === "QUOTING" || multilangJob.status === "QUOTED") {
    return (palette.lightGold as any)[200]
  }
  return '#A0E8FF'//(palette.lightSkyBlue as any)[100]
}

const onHoverBackgroundColor = (multilangJob: MultilangJob, palette: Palette) => {
  return buttonBorderColor(multilangJob, palette)
}

export const ViewLinkButton = ({ onClick, children, multilangJob }: { onClick: () => void; children: React.ReactNode; multilangJob: MultilangJob }) => {
  const { palette } = useTheme()
  return (
    <Button
      variant="contained"
      color="primary"
      onClick={onClick}
      sx={{
        backgroundColor: languagesRowLabelColor(multilangJob, palette),
        border: `1px solid ${buttonBorderColor(multilangJob, palette)}`,
        fontSize: "0.625rem",
        px: 1.5,
        py: 0.25,
        width: "fit-content",
        "&:hover": {
          backgroundColor: onHoverBackgroundColor(multilangJob, palette),
          boxShadow: "0px 0px 5px #01294E33"
        }
      }}
    >
      {children}
    </Button>
  )
}
